import React from "react";
import { useSelector } from "react-redux";
import {
  getElementById,
  getContainerClass,
  getLabelStyles,
  getInputStyles,
} from "../utils/styleUtils";

export const CustomNumberInput = ({ instanceId, field, form, ...props }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Number input element not found</div>;
  }

  const elementStyle = element.style || {};
  const labelPosition = elementStyle.labelPosition || "top";

  const handleInputChange = (e) => {
    if (field && form) {
      form.setFieldValue(field.name, e.target.value);
    }
  };

  return (
    <div className={getContainerClass(labelPosition)} style={{ width: "100%" }}>
      {elementStyle.label?.label && (
        <label
          htmlFor={`number-${instanceId}`}
          style={getLabelStyles(elementStyle, labelPosition)}
        >
          {elementStyle.label.label}
          {elementStyle.isRequired && (
            <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
          )}
        </label>
      )}

      <input
        id={`number-${instanceId}`}
        type="number"
        placeholder={elementStyle.placeholderText || "0"}
        value={field?.value || ""}
        onChange={handleInputChange}
        required={elementStyle.isRequired}
        min={elementStyle.minValue}
        max={elementStyle.maxValue}
        step={elementStyle.step || "1"}
        style={getInputStyles(elementStyle, labelPosition)}
        className="form-control"
        {...props}
      />

      {elementStyle.helpText && (
        <small className="text-muted mt-1" style={{ fontSize: "0.75rem" }}>
          {elementStyle.helpText}
        </small>
      )}

      {(elementStyle.minValue !== undefined ||
        elementStyle.maxValue !== undefined) && (
        <small
          className="text-muted mt-1 d-block"
          style={{ fontSize: "0.75rem" }}
        >
          {elementStyle.minValue !== undefined &&
          elementStyle.maxValue !== undefined
            ? `Value must be between ${elementStyle.minValue} and ${elementStyle.maxValue}`
            : elementStyle.minValue !== undefined
            ? `Minimum value: ${elementStyle.minValue}`
            : `Maximum value: ${elementStyle.maxValue}`}
        </small>
      )}
    </div>
  );
};
